<template>
  <div class="IDcard">
    <div class="cardPic">
      <div class="zhenjian">
        <div class="leftIcon">
          <img src="../assets/images/yinyeIcon.png" alt="" />
        </div>
        <div class="word">
          <div class="zhenjianName">营业执照</div>
          <div class="pingzhen">电子凭证</div>
        </div>
      </div>
      <div class="dibu" v-show="hasCard" >
       <div class="left" @click="goView"> <!-- <img src="../assets/images/dianziIcon.png" alt="" /> -->
        <div class="word">查看电子证照</div></div>
        <div class="right" @click="handleKookCodeClick">
          <div class="word">查看二维码</div>
          <img
            style="
              height: 14px;
              width: 14px;
              margin-left: 5px;
              vertical-align: middle;
            "
            src="../assets/images/code-icon.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="shuoming">
      <div class="title">证件说明</div>
      <div class="miaosu">
        <div class="miaosuTitle">证件描述:</div>
        <div class="miaosuWord">
          本证件系与苏州市市场监管部门核发的营业执照相对应的电子标签，仅限于在苏州市行政区域范围内使用。
        </div>
      </div>
      <div class="fanwei">
        <div class="fanweiTitle">适用范围:</div>
        <div class="fanweiWord">
          1、出示营业执照以表明市场主体身份或使用营业执照进行市场主体身份认证和证明；<br />
          2、办理市场主体登记注册业务；<br />
          3、以市场主体身份登录网上 系统或平台、办理各项业务、开展经营活动；<br />
          4、登录国家企业信用信息公示系统报送年度报告、自主公示信息； <br />
          5、以市场主体身份对电子文件、表单或数据等进行电子签名； <br />
          6、在互联网上公开营业执照信息和链接标识；<br />
          7、授权相关个人或单位共享、传输或获取其市场主体数据信息； <br />
          8、按照法律、法规和相关规定需要使用和提供营业执照。<br />
        </div>
      </div>
      <div class="changjin">以上电子营业执照可应用的情形，供市场主体参考。</div>
    </div>
    <van-popup v-model="codeShow" class="my-popup">
      <vue-qr
        :size="191"
        :margin="0"
        :auto-color="true"
        :dot-scale="1"
        :text="appSrc"
      />
    </van-popup>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import qs from "qs";
import VueQr from "vue-qr";

import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  mounted() {

    this.chakan();
  },
  data() {
    return {
      hasCard: false,
      noCard: false,
      data: null,

      appSrc: "",
      codeShow: false,
    };
  },
  components: { VueQr },

  methods: {
    handleKookCodeClick() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({ cardType: 3 });
      this.$axios
        .post("/identity/user/otherCert/getQRcode", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            this.codeShow = true;
            this.appSrc = res.data.data;
          }
        })
        .catch((err) => {
          Toast.clear();
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    goView() {
      this.$router.push({
        name: "ZhenjianView",
        params: {
          src: this.data.pdf,
        },
      });
    },

    chakan() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        cardType: 3,
      });
      this.$axios
        .post("identity/user/elecCertificate/getCertificateInfo", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear()
            Dialog.alert({
              message: "未查询到相关证件信息",
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear()
            this.data = res.data.data;

            if (JSON.stringify(this.data) == "{}") {
              this.noCard = true;
            } else {
              this.hasCard = true;
            }
          }
        })
        .catch((err) => {
          Toast.clear()
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    getToken() {
      let token = this.$route.query.token;
      localStorage.setItem("token", token);
    },
  },
};
</script>

<style lang="scss" scoped>
.IDcard {
  background-color: #eef4f6;
  padding: 1.5rem 2rem 6.25rem 2rem;
  height: auto;
}
.cardPic {
  position: relative;
  background-image: url("../assets/images/yinye.png");
  height: 25rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 4.25rem;
  padding-left: 3.375rem;
  .zhenjian {
    display: flex;
    align-items: center;

    img {
      width: 5.5rem;
    }
    .word {
      margin-left: 1.625rem;
      line-height: 3rem;
      .zhenjianName {
        color: #ffffff;
        font-size: 2rem;
      }
      .pingzhen {
        color: rgba(255, 255, 255, 0.8);
        font-size: 1.625rem;
      }
    }
  }
  .dibu {
    width: 100%;
    background-image: url("../assets/images/dianziBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5.5rem;
    .left {
      position: relative;
    }
    .left::after {
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -7px;
      content: "";
      height: 14px;
      width: 1px;
      background-color: #fff;
    }
    .left,
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
    }
    div {
      .word {
        margin-left: 1.25rem;
        font-size: 1.875rem;
        color: #ffffff;
      }
      img {
        width: 3.25rem;
        height: 2.375rem;
      }
    }
  }
}
.my-popup {
  padding: 10px;
}
.shuoming {
  margin-top: 1.25rem;
  background-color: #fff;
  padding: 2.5rem 2rem 1.5rem 2rem;
  border-radius: 1rem;
  .title {
    font-size: 2.125rem;
    color: #19212a;
  }
  .miaosu {
    margin-top: 2.125rem;
    color: #555555;
    font-size: 1.6875rem;
    .miaosuWord {
      margin-top: 1.25rem;
    }
  }
  .fanwei {
    color: #555555;
    font-size: 1.6875rem;
    margin-top: 3.75rem;
    .fanweiWord {
      margin-top: 1.25rem;
      line-height: 3.25rem;
    }
  }
  .changjin {
    color: #555555;
    font-size: 1.6875rem;
    margin-top: 1.25rem;
  }
}
</style>